import { defineComponent as c, createElementBlock as d, openBlock as t, createElementVNode as o, createBlock as n, unref as a, toDisplayString as m, createVNode as l } from "vue";
import { ScalarIconX as b, ScalarIconList as p, ScalarIconMagnifyingGlass as u } from "@scalar/icons";
import g from "./DarkModeToggle.vue.js";
const h = { class: "t-doc__header mobile-header" }, S = { class: "mobile-header-breadcrumbs" }, _ = { class: "mobile-header-actions" }, w = /* @__PURE__ */ c({
  __name: "DocumentMobileHeader",
  props: {
    label: {},
    showSideBar: { type: Boolean }
  },
  emits: ["showSearch", "toggleSidebar"],
  setup(k, { emit: i }) {
    const r = i;
    return (s, e) => (t(), d("div", h, [
      o("button", {
        class: "icon-button",
        type: "button",
        onClick: e[0] || (e[0] = () => r("toggleSidebar"))
      }, [
        s.showSideBar ? (t(), n(a(b), { key: 0 })) : (t(), n(a(p), { key: 1 }))
      ]),
      o("span", S, m(s.label), 1),
      o("div", _, [
        o("button", {
          class: "icon-button",
          type: "button",
          onClick: e[1] || (e[1] = () => r("showSearch"))
        }, [
          l(a(u))
        ]),
        l(g, { class: "mobile-header-darkmode-toggle" })
      ])
    ]));
  }
});
export {
  w as default
};
